var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("专题研讨")])
}
var staticRenderFns = []

export { render, staticRenderFns }